import TransactionHistory from "@/views/transaction/TransactionHistory";

export default {
  TransactionHistory,
};
